export default function transformToOption(options, field = "name"){
  if (Array.isArray(options)) {
    return options.map(item => ({
      value: item.id,
      label: item[field]
    }))
  }
  
  return [{ value: options.id, label: options[field]}]
}